import { useEffect, useState } from 'react';

import httpApplication from 'app/http/httpApiApplication';
import httpSecurity from 'app/http/httpApiSecurity';
import { makeUseAxios, type UseAxios, type UseAxiosResult } from 'axios-hooks';
import queryString from 'query-string';
import { buildParams } from 'utils/params';

import { type GET } from './types';

export const buildUrlWithQueryString = (url: string, params: any) => {
  function hasPropertiesWithValues() {
    return Object.keys(params).length > 0;
  }

  if (params) {
    buildParams(params);
    const queryStr = hasPropertiesWithValues() ? `?${queryString.stringify(params)}` : '';
    return `${url}${queryStr}`;
  }
  return url;
};

export const useHttpApplication: UseAxios = makeUseAxios({
  axios: httpApplication.service,
  cache: false
});

export const useHttpSecurity = makeUseAxios({
  axios: httpSecurity.service,
  cache: false
});

export const useGetApplication = <T>(
  { url, params, headers }: GET,
  onLoad = true
): UseAxiosResult<T, any, any> => {
  const newUrl = buildUrlWithQueryString(url, params);
  const result = useHttpApplication<T>(
    { url: newUrl, headers: headers },
    { useCache: false, manual: !onLoad }
  );

  return result;
};

export const useGetSecurity = <T>(
  { url, params }: GET,
  onLoad = true
): UseAxiosResult<T, any, any> => {
  const newUrl = buildUrlWithQueryString(url, params);
  const result = useHttpSecurity<T>({ url: newUrl }, { useCache: false, manual: !onLoad });
  return result;
};

export const usePaginateApplication = <T>(
  url: string,
  pageIn: number,
  sizeIn: number,
  params: any = {},
  inMemory = false
) => {
  // const [page, setPage] = useState(pageIn);
  const [pageSize, setPageSize] = useState(sizeIn);
  const [myParams, setMyParams] = useState(params);

  const result = useGetApplication<T>(
    {
      url,
      params: {
        pageSize,
        page: pageIn,
        ...params
      }
    },
    !inMemory
  );

  // const result = useGetApplication<Paginated<T>>(
  //   {
  //     url,
  //     params: { pageSize, page: page, ...myParams }
  //   },
  //   !inMemory
  // );
  // const [response, refetch] = result;

  // useEffect(() => {
  //   setMyParams(params);
  //   setPage(1);
  // }, [params, setMyParams, setPage]);

  // useEffect(() => {
  //   setPage(pageIn);
  // }, [pageIn, setPage]);

  // useEffect(() => {
  //   setPage(1);
  //   setPageSize(sizeIn);
  // }, [sizeIn, setPageSize, setPage]);

  return result;
};

export const usePaginateSecurity = <T>(
  url: string,
  pageIn: number,
  sizeIn: number,
  params: any = {},
  inMemory = false
) => {
  const [page, setPage] = useState(pageIn);
  const [pageSize, setPageSize] = useState(sizeIn);
  const [myParams, setMyParams] = useState(params);

  const result = useGetSecurity<T>(
    {
      url,
      params: { pageSize, page: page, ...myParams }
    },
    !inMemory
  );
  const [response, refetch] = result;

  useEffect(() => {
    setMyParams(params);
    setPage(1);
  }, [params, setMyParams, setPage]);

  useEffect(() => {
    setPage(pageIn);
  }, [pageIn, setPage]);

  useEffect(() => {
    setPage(1);
    setPageSize(sizeIn);
  }, [sizeIn, setPageSize, setPage]);

  return result;
};
